var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"appear":""}},[_c('div',{staticClass:"progress-fake"})])
}
var staticRenderFns = []

export { render, staticRenderFns }